import { render, staticRenderFns } from "./LocationColored.vue?vue&type=template&id=06de7bcc&scoped=true"
import script from "./LocationColored.vue?vue&type=script&lang=js"
export * from "./LocationColored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de7bcc",
  null
  
)

export default component.exports